
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[linkId]",
      function () {
        return require("private-next-pages/[linkId]/index.tsx");
      }
    ]);
  